module.exports = __webpack_public_path__ + "img/hugo-smc.9d81310a.jpg";